/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Button, Form, Modal, Row, Tab, Tabs } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import UrlService from '../../../services/UrlService';
import { useD3Report } from './ContextAPI';
import DataTable from './DataTable';
import Loader from '../../Loader';

export default function ShowModel() {
    const { show, setShow, data, modalLoading, setShowPdf, partner, setPartner } = useD3Report();
    const axiosPrivate = useAxiosPrivate();
    const [page, setPage] = useState(0);
    const [pageLength, setPageLength] = useState(0);

    useEffect(() => {
        if (partner?.length > 0) return;
        const fetchPartner = async () => {
            try {
                const response = await axiosPrivate.get(UrlService.getAllPartnerUrl(), {
                    headers: { 'Content-Type': 'application/json' },
                });
                setPartner(response?.data?.partner_info);
            } catch (err) {
                if (!err?.response) {
                    console.log('Server Not Responding!');
                } else if (err.response?.status === 401) {
                    console.log('Unauthorized!');
                } else {
                    console.log('Partner Data Not Found!');
                }
            }
        };
        fetchPartner();
    }, []);

    useEffect(() => {
        setPageLength(data?.d3_records?.length);
        if (data?.d3_records?.length) {
            setPage(data.d3_records[0].id);
        }
    }, [data?.d3_records]);

    const handleClose = () => {
        setShow(false);
    };

    const handlePrintPreview = () => {
        setShow(false);
        setShowPdf(true);
    };

    const exportToExcel = () => {
        if (!data?.d3_records?.length) return;

        const wb = XLSX.utils.book_new();

        const dateRange = data?.month && data?.year
            ? `${['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][data.month]} - ${data.year}`
            : `${moment(data.start_date).format('DD MMM YYYY')} - ${moment(data.end_date).format('DD MMM YYYY')}`;

        data.d3_records.forEach((category) => {
            if (!category.drug_list?.length) return;

            const totalCols = 1 + (partner?.length || 0) * 2 + 2;

            const merges = [];
            const titleRow = ['Item Name', dateRange];
            const partnerHeaderRow = [''];
            const subHeaderRow = [''];
            let col = 1;

            partner?.forEach((p) => {
                partnerHeaderRow.push(p.name, '');
                merges.push({ s: { r: 1, c: col }, e: { r: 1, c: col + 1 } });
                subHeaderRow.push(
                    'UNHCR Stock Consumption',
                    'Monthly Consumption (Non-UNHCR & Stock Out Days)'
                );
                col += 2;
            });

            const totalStart = col;
            partnerHeaderRow.push('Total', '');
            merges.push({ s: { r: 1, c: totalStart }, e: { r: 1, c: totalStart + 1 } });
            subHeaderRow.push(
                'Total UNHCR Stock Consumption',
                'Total Monthly Consumption (Non-UNHCR & Stock Out Days)'
            );

            merges.push({ s: { r: 0, c: 0 }, e: { r: 2, c: 0 } });
            merges.push({ s: { r: 0, c: 1 }, e: { r: 0, c: totalCols - 1 } });

            const rows = [titleRow, partnerHeaderRow, subHeaderRow];

            category.drug_list.forEach((drug) => {
                const row = [drug.drug_name];
                partner?.forEach((p) => {
                    const item = drug.partner_summary_data?.find(
                        (s) => s && parseInt(s.partner_id, 10) === parseInt(p.id, 10)
                    );
                    row.push(Number(item?.total_consumed) || 0);
                    row.push(Number(item?.total_non_unhcr_consumed) || 0);
                });
                row.push(
                    (drug.partner_summary_data || []).reduce(
                        (a, s) => a + (Number(s.total_consumed) || 0),
                        0
                    )
                );
                row.push(
                    (drug.partner_summary_data || []).reduce(
                        (a, s) => a + (Number(s.total_non_unhcr_consumed) || 0),
                        0
                    )
                );
                rows.push(row);
            });

            const ws = XLSX.utils.aoa_to_sheet(rows);
            ws['!merges'] = merges;

            [0, 1, 2].forEach((r) => {
                for (let c = 0; c < totalCols; c += 1) {
                    const addr = XLSX.utils.encode_cell({ r, c });
                    if (ws[addr]) {
                        ws[addr].s = { alignment: { horizontal: 'center', vertical: 'center' } };
                    }
                }
            });

            const colWidths = [{ wch: 30 }];
            partner?.forEach(() => {
                colWidths.push({ wch: 22 });
                colWidths.push({ wch: 35 });
            });
            colWidths.push({ wch: 22 });
            colWidths.push({ wch: 35 });
            ws['!cols'] = colWidths;

            XLSX.utils.book_append_sheet(wb, ws, category.name?.slice(0, 31));
        });

        XLSX.writeFile(wb, 'D3_Consumption_Report.xlsx');
    };

    const tableDataDisplay = () =>
        data?.d3_records?.map((item) => (
            <Tab key={item.id} eventKey={item.id} title={item.name}>
                <DataTable
                    medicinData={item.drug_list}
                    partner={partner}
                    dateOrMonthRange={
                        data.month && data.year
                            ? `${
                                  data?.month == 1
                                      ? 'January'
                                      : data?.month == 2
                                      ? 'February'
                                      : data?.month == 3
                                      ? 'March'
                                      : data?.month == 4
                                      ? 'April'
                                      : data?.month == 5
                                      ? 'May'
                                      : data?.month == 6
                                      ? 'June'
                                      : data?.month == 7
                                      ? 'July'
                                      : data?.month == 8
                                      ? 'August'
                                      : data?.month == 9
                                      ? 'September'
                                      : data?.month == 10
                                      ? 'October'
                                      : data?.month == 11
                                      ? 'November'
                                      : data?.month == 12
                                      ? 'December'
                                      : ''
                              } - ${data.year}`
                            : `${moment(data.start_date).format('DD MMM YYYY')} - ${moment(
                                  data.end_date
                              ).format('DD MMM YYYY')}`
                    }
                />
            </Tab>
        ));

    return (
        <Modal className="modalWidth80" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>D3 Consumption Reports</Modal.Title>
                <div className="ms-auto d-flex">
                    <Button className="btn btn-dark me-2" onClick={handlePrintPreview}>
                        Print Preview
                    </Button>
                    <Button className="btn btn-success me-2" onClick={exportToExcel}>
                        Export Excel
                    </Button>
                </div>
            </Modal.Header>
            <Modal.Body>
                {modalLoading || !data?.d3_records ? (
                    <Loader />
                ) : (
                <Form>
                    <Row>
                        <Tabs
                            activeKey={page}
                            transition={false}
                            id="noanim-tab-example"
                            className="mb-3"
                            // eslint-disable-next-line radix
                            onSelect={(k) => setPage(parseInt(k))}
                        >
                            {tableDataDisplay()}
                        </Tabs>
                    </Row>

                    <Modal.Footer className="borderTop0 pe-0">
                        <Button className="btnCancel" variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button
                            className="btnInfo me-2 ms-2"
                            variant="primary"
                            style={{ minWidth: '6rem' }}
                            disabled={page === 0}
                            onClick={() => {
                                setPage((currPage) => currPage - 1);
                            }}
                        >
                            Prev
                        </Button>
                        <Button
                            type="button"
                            className="btnSuccess"
                            disabled={page === pageLength}
                            variant="success"
                            style={{ minWidth: '6rem' }}
                            onClick={() => setPage((currPage) => currPage + 1)}
                        >
                            Next
                        </Button>
                    </Modal.Footer>
                </Form>
                )}
            </Modal.Body>
        </Modal>
    );
}
